export default __webpack_public_path__ + "static/media/island_3.060fb4f2.png";